// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareEntityButtonStyles } from "@awc/Overrides/Components/ShareEntityButton";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, mergeWithCss, modalButtonsActionStyles } from "@awc/XDL/Utilities";
import { css } from "styled-components";

shareEntityButtonStyles.messageTextArea = {
    css: css`
        resize: vertical;
    `,
};

shareEntityButtonStyles.button = {
    variant: "secondary",
};

shareEntityButtonStyles.container = {
    gap: 5,
};

shareEntityButtonStyles.buttonsWrapper = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            margin-top: 20px;
        `,
    }),
};

shareEntityButtonStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

shareEntityButtonStyles.sendButton = {
    ...modalButtonsActionStyles.submitButton,
};

shareEntityButtonStyles.emailFromGridItem =
    shareEntityButtonStyles.emailToGridItem =
    shareEntityButtonStyles.messageGridItem =
    shareEntityButtonStyles.subjectGridItem =
    shareEntityButtonStyles.requiredTextGridItem =
        {
            width: 12,
        };

shareEntityButtonStyles.requiredText = {
    css: css`
        &:before {
            content: "*";
            color: ${color("danger")};
            margin-right: 5px;
        }
        margin-bottom: 16px;
    `,
};

shareEntityButtonStyles.pdfLink = {
    typographyProps: {
        size: fontConfig.fontSize.link,
        lineHeight: fontConfig.lineHeight.regular,
        css: css`
            margin-bottom: 20px;
        `,
    },
};
